import hiddenPropertiesReducer from './hidden-properties.slice';

export * from './hidden-properties.slice';
export * from './hidden-properties.thunk';

export default hiddenPropertiesReducer;
